import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, LoadingController, NavController } from 'ionic-angular';
import { EventProvider } from '../../../../../../../providers/event/event';
import { activities, ITeam, LineUpService, TshirtStyle } from '../../../../../lineup/services/lineup-service';
import { TournamentService, IPlan, offlineUnloadKey$, PlanEnum } from '../../../../services/tournament.service';
import { SportAlgoUtils } from '../../../../services/sport.algo';

@Component({
  selector: 'pre-round',
  templateUrl: 'pre-round.html',
})
export class PreRoundPage {
  plan = {
    id: new Date().getTime(),
    plantype: PlanEnum.VorPage,
    sporttype: 4,
    eventId: 0,
    name: "",
    rounds: 1,
    games: 18,
    teamNum: 8,
    groupNum: 2,
    groupSize: 4,
    date: "",
    time: "",
    teams: [],
    gameTable: []
  };

  events = [];

  constructor(
    private gs: TournamentService,
    private app: App,
    private ls: LineUpService,
    private navCtrl: NavController,
    private loader: LoadingController,
    private eventService: EventProvider,
    private translate: TranslateService
  ) {
    this.getEvents();
  }

  getEvents() {
    this.eventService.getClientEvents().then(events => {
      this.events = events;
      if(events) this.plan.eventId = this.events[0].id;
    });
  }

  ionViewDidLoad() {
    this.plan.name = "Spielplan " + (this.gs.planList.length + 1);
  }

  getSportName(){
    return this.translate.instant(activities[this.plan.sporttype].path);
  }

  save() {
    this.createTeams().then(teams => {
      this.plan.teams = teams;
      this.setMatches();
      let load = this.loader.create({});
      load.present();
      this.gs.saveTou(this.plan).then(plan => {
        this.plan = plan;
        this.gs.planList.push(this.plan);
        this.gs.save();
        this.gs.$planListChangeSub.next();
        load.dismiss();
      });
      this.navigate();
    });
  }

  filter(plan: any) {
    let obj = JSON.parse(JSON.stringify(plan));
    delete obj.gameTable;
    delete obj.id;
    return obj;
  }

  navigate() {
    let load = this.loader.create({});
    load.present();
    this.app.getRootNav().getActiveChildNav().select(0);
    this.navCtrl.popToRoot().then(() => {
      console.log('done');
      load.dismiss();
      this.app.getRootNav().getActiveChildNav().select(1);
    });
  }

  onGroupSizeChange() {
    this.plan.groupSize = Math.floor(this.plan.groupSize);
    this.plan.teamNum = Math.floor(this.plan.groupNum) * Math.floor(this.plan.groupSize);
  }

  onGroupNumChange() {
    this.plan.groupNum = Math.floor(this.plan.groupNum);
    this.plan.teamNum = this.plan.groupNum * this.plan.groupSize;
  }

  onTeamNumChange() {
    this.plan.teamNum = Math.floor(this.plan.teamNum);
    this.plan.groupNum = this.plan.teamNum / this.plan.groupSize;
    this.countGames();
  }

  onGroupSizeChangeMan() {
    this.plan.groupSize = Math.floor(this.plan.groupSize);
  }

  onGroupNumChangeMan() {
    this.plan.groupNum = Math.floor(this.plan.groupNum);
  }

  onTeamNumChangeMan() {
    this.plan.teamNum = Math.floor(this.plan.teamNum);
  }

  createTeams() {
    return new Promise<any>((resolve, reject) => {
      let gN = Number(this.plan.groupNum);
      let gS = Number(this.plan.groupSize);

      let ASCII = 65;
      let id = 0;
      for (let i = 0; i < gN; i++) {
        for (let j = 0; j < gS; j++) {
          let team: ITeam = {
            id: new Date().getTime() + id,
            name: 'Team ' + String.fromCharCode(ASCII) + (j + 1),
            results: 0,
            points: 0,
            image: null,
            ord:id + 1,
            players: []
          };
          this.plan.teams.push(team);
        }
        id += 1;
        ASCII += 1;
      }
      if(navigator.onLine){
        this.gs.saveTeams(this.plan.teams).then(teams => resolve(teams));
      }else{
        localStorage.setItem(offlineUnloadKey$, "true");
        resolve(this.plan.teams);
      }
    });
  }

  matchRecursive(n: number): number {
    if (n <= 1) {
      return this.count += 1;
    } else {
      this.count += 1;
      return this.matchRecursive(n / 2);
    }
  }

  count = 0;
  countGames() {
    this.count = 0;
    let gN = Number(this.plan.groupNum);
    let gS = Number(this.plan.groupSize);

    for (let r = 0; r < this.plan.rounds; r++) {
      for (let i = 0; i < gN; i++) {
        this.count += SportAlgoUtils.calcGames(gS, 2);
      }
    }

    this.matchRecursive(this.count);
    this.plan.games = this.count;
  }

  setMatches() {
    let gN = Number(this.plan.groupNum);
    let gS = Number(this.plan.groupSize);

    for (let r = 0; r < this.plan.rounds; r++) {
      let roundTable = [];
      for (let i = 0; i < gN; i++) {
        let table = SportAlgoUtils.createGamePlan(this.plan.teams.slice(i * gS, i * gS + gS), gS, this.plan);
        roundTable.push(table);

      }
      this.plan.gameTable.push(roundTable);
    }
  }

}







// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/new-tou/new-plan/pre-round/pre-round.ts